import _ from 'lodash';
import { Dispatch } from 'redux';
import { postEmployee, putEmployment } from '../../../../global/ducks/person-prc-api';
import { getFormattedDateYmd } from '../../../../global/helpers/date-helpers';
import { formatDate, parsePhone } from '../../../../global/helpers/form-data-helper';
import { YesNoIndicators } from '../../../../global/models/api-model';
import { ClergyNewHireFormValues, CompensationRecordType, NewHireFormValues, NonStipNewHireFormValues, StipNewHireFormValues } from './models/new-hire-form-model';

const housingProvided = 'housing';

const getEmploymentCompPayload = (isStip: boolean, values: NewHireFormValues, payload: any) => {

	let copy = _.cloneDeep(payload);

	if (isStip) {
		const stipValues = values as StipNewHireFormValues;
		copy = {
			...copy,
			hire_date: formatDate(stipValues.hire_date),
			current_position_title: stipValues.position_title,
			current_scheduled_hours: stipValues.hours,
			non_stipendiary_positions_indicator: YesNoIndicators.No,
			current_scheduled_hours_start_date: formatDate(stipValues.scheduled_hours_effective_date),  
			current_position_title_start_date: formatDate(stipValues.position_efective_date),  
			current_position_published_title: stipValues.published_title,
		};

		if (stipValues.record_type === CompensationRecordType.ScheduledPayment)
			copy = {
				...copy,
				compensation_cash_salary: stipValues.base_salary,
				compensation_effective_date: formatDate(stipValues.compensation_effective_date),
				compensation_er_plan_contributions: stipValues.employer_contributions,
				compensation_housing_cash_allowance: stipValues.cash_housing_allowance,
				compensation_housing_provided: stipValues.employer_provided_housing === YesNoIndicators.Yes ? housingProvided : null,
				post2018_housing_provided: stipValues.employer_provided_housing === YesNoIndicators.Yes ? housingProvided : null,
			};
		else
			copy = {
				...copy,
				otp_amount: stipValues.amount,
				otp_effective_date: formatDate(stipValues.compensation_effective_date),
			};

	} else {
		const nonStipValues = values as NonStipNewHireFormValues;
		copy = {
			...copy,
			termination_date: nonStipValues.end_date && formatDate(nonStipValues.end_date),
			hire_date: formatDate(nonStipValues.start_date),
			current_position_title: nonStipValues.position_title,
			current_position_title_start_date: formatDate(nonStipValues.position_start_date),
			current_position_title_end_date: nonStipValues.position_end_date ? formatDate(nonStipValues.position_end_date) : null,
			current_position_published_title: nonStipValues.published_title,
			non_stipendiary_positions_indicator: YesNoIndicators.Yes,
		};
	}

	const clergyNewHireValues = values as ClergyNewHireFormValues;

	if (clergyNewHireValues?.is_another_denomination === YesNoIndicators.Yes) {
		copy = {
			...copy,
			licensing_start_date: getFormattedDateYmd(clergyNewHireValues?.date_licensing, true),
			licensing_bishop_guid: clergyNewHireValues?.licensed_by,
			licensing_organization_client_number: clergyNewHireValues?.diocese_licensed_in,
		};
	}

	//Remove Empty Props
	const keys = Object.keys(copy);
	keys.forEach(a => {
		if (!copy[a]) {
			delete copy[a];
		}
	});

	return copy;
};

export function ProcessNewHirePost(values: NewHireFormValues, isStip: boolean, employerClientNumber: string, dispatch: Dispatch<any>, onSuccess: (noStip: boolean, employee: any, values: ClergyNewHireFormValues) => void) {

	//Set Demographic Props
	let payload: any = {
		first_name: values.first_name,
		middle_name: values.middle_name,
		last_name: values.last_name,
		suffix: values.suffix,
		date_of_birth: formatDate(values.date_of_birth),
		designation_salutation: values.designation_salutation,
		office_email_address: values.office_email_address,
		personal_email_address: values.personal_email_address,
		gender: values.gender,
		gender_identity: values.gender_identity,
		gender_identity_other: values.gender_identity_other,
		tax_id: values.tax_id,
		employer_client_number: employerClientNumber,
		known_as: values.known_as,
		mailing_address_1: values.mailing_address_1,
		mailing_address_2: values.mailing_address_2,
		mailing_address_3: values.mailing_address_3,
		mailing_city: values.mailing_city,
		mailing_country: values.mailing_country,
		mailing_state: values.mailing_state,
		mailing_postal_code: values.mailing_postal_code,
		business_phone_extension: values.business_phone_extension,
		business_phone_country_code: values.business_phone_country_code,
		mobile_phone_country_code: values.mobile_phone_country_code,
		home_phone_country_code: values.home_phone_country_code,
		business_phone_formated: values.business_phone_formated,
		mobile_phone_formated: values.mobile_phone_formated,
		home_phone_formated: values.home_phone_formated,
	};

	payload = parsePhone(payload);
	payload = getEmploymentCompPayload(isStip, values, payload);
	payload = {
		...payload,
		isMatchPerson: false,
	};

	dispatch(postEmployee(payload, (data) => onSuccess(!isStip, data?.data, values as ClergyNewHireFormValues)));


}


export function ProcessNewHirePostWithExistingPerson(values: NewHireFormValues, selectedPersonGuid: string, isStip: boolean, employerGuid: string, dispatch: Dispatch<any>, onSuccess: (noStip: boolean, employee: any, values: ClergyNewHireFormValues) => void) {

	let payload = getEmploymentCompPayload(isStip, values, null);

	payload = {
		...payload,
		employee_guid: selectedPersonGuid,
		employer_guid: employerGuid,
	};


	dispatch(putEmployment(payload, selectedPersonGuid, (data) => onSuccess(!isStip, data?.data, values as ClergyNewHireFormValues)));

}


export function mapErrorToNewHireStipKey(errorKey: string) {
	switch (errorKey) {
		case 'mailing_address':
			return 'mailing_address_1';
		case 'effective_date':
			return 'compensation_effective_date';
		case 'scheduled_hour':
			return 'scheduled_hours_effective_date';
		case 'start_date':
			return 'position_efective_date';
		case 'current_position_title_start_date':
			return 'hire_date';
		default:
			return errorKey;
	}
}

export function mapErrorToNewHireNoneStipKey(errorKey: string) {
	switch (errorKey) {
		case 'mailing_address':
			return 'mailing_address_1';
		case 'effective_date':
			return 'compensation_effective_date';
		case 'scheduled_hour':
			return 'scheduled_hours_effective_date';
		case 'start_date':
			return 'position_efective_date';
		case 'current_position_title_start_date':
			return 'hire_date';
		default:
			return errorKey;
	}
}